import SEOHead from "@/components/SEOHead";
import InPersonQuoteBuilder from "@/components/InPersonQuoteBuilder";
import TrustBar from "@/components/TrustBar";
import RelatedTools from "@/components/RelatedTools";
import SolutionsCrossSell from "@/components/SolutionsCrossSell";
import { CheckCircle } from "lucide-react";

export default function InPersonQuotePage() {
  return (
    <div>
      <SEOHead title="In-Person Payment Estimate" description="Get an instant estimate for in-person card payments, terminals, and EPOS. See your likely monthly costs in seconds." path="/quote/in-person" />

      <section className="py-10 md:py-16 bg-gray-50" id="quote" data-testid="quote-section">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-6">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-aqua mb-2">Instant Estimate</p>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-brand-black tracking-tight mb-3">See what in-person payments could cost</h1>
            <p className="text-brand-grey leading-relaxed max-w-xl mx-auto">Enter your business details and get an instant indicative estimate. No obligation, no sign-up.</p>
          </div>
          <InPersonQuoteBuilder />
        </div>
      </section>

      <TrustBar />

      <section className="py-14 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-2xl font-bold text-brand-black mb-6">Why businesses choose CanDo</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left max-w-lg mx-auto">
            {["Transparent pricing — no hidden fees", "PCI compliant, 3-D Secure, tokenisation as standard", "Next-day terminal setup (order before 2pm)", "Powered by Elavon and U.S. Bank infrastructure"].map((item) => (
              <div key={item} className="flex items-start gap-2 text-sm text-brand-black"><CheckCircle size={16} className="text-brand-aqua flex-shrink-0 mt-0.5" />{item}</div>
            ))}
          </div>
        </div>
      </section>

      <RelatedTools currentPath="/quote/in-person" />
      <SolutionsCrossSell currentPath="/quote/in-person" />
    </div>
  );
}
